export default __webpack_public_path__ + "static/media/game.33671e79.svg";